import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const BeforePublicationforDean = () => {
  const [publications, setPublications] = useState([]);
  const [filteredPublications, setFilteredPublications] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [deptFilter, setDeptFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');

  const userId = sessionStorage.getItem('userId');
  const history = useHistory();

  const fetchPublications = async (userId, deptId = '') => {
    try { 
      const url = deptId
        ? `${process.env.REACT_APP_API_BASE_URL}/beforepublications/pending?userId=${userId}&deptId=${deptId}`
        : `${process.env.REACT_APP_API_BASE_URL}/beforepublications/pending?userId=${userId}`;
//alert(url);
      const response = await axios.get(url);
      setPublications(response.data);
      //alert(response.data)
      setFilteredPublications(response.data);
    } catch (error) {
      console.error('Error fetching publications:', error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/departments`); // Your department list endpoint
      setDepartments(response.data);
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  useEffect(() => {
    fetchDepartments();
    fetchPublications(userId);
  }, []);

  const getStatusText = (status) => {
    if (status === '3') return 'Approved';
    if (status === '1') return 'Pending';
    
    return 'Not Approved';
  };

  const handleView = (id) => {
    history.push(`/beforedeanapproved/view/${id}`);
  };
   const handleEdit = (id) => {
    history.push(`/beforepublicationfordean/edit/${id}`);
  };


  const handleStatusChange = (e) => {
    const selected = e.target.value;
    setStatusFilter(selected);

    applyFilters(selected, deptFilter);
  };

  const handleDeptChange = (e) => {
    const selectedDept = e.target.value;
    setDeptFilter(selectedDept);
    fetchPublications(userId, selectedDept);
  };

  const applyFilters = (status, dept) => {
    let filtered = [...publications];

    if (status !== 'All') {
      const statusMap = {
        Approved: '3',
        Rejected: '2',
        'Not Approved': '1',
      };
      filtered = filtered.filter(pub => pub.status === statusMap[status]);
    }

    setFilteredPublications(filtered);
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="text-primary">Before Publications</h3>
        <div className="d-flex gap-2">
          <select
            className="form-select"
            style={{ width: '180px' }}
            value={deptFilter}
            onChange={handleDeptChange}
          >
            <option value="">All Departments</option>
            {departments.map((dept) => (
              <option key={dept.deptId} value={dept.deptId}>
                {dept.deptName}
              </option>
            ))}
          </select>

          <select
            className="form-select"
            style={{ width: '160px' }}
            value={statusFilter}
            onChange={handleStatusChange}
          >
            <option value="All">All</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
            <option value="Not Approved">Not Approved</option>
          </select>
        </div>
      </div>

      <table className="table table-bordered table-hover">
        <thead className="table-dark">
          <tr>
            <th>ID</th>
            <th>Paper Title</th>
            <th>Journal</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredPublications.length > 0 ? (
            filteredPublications.map((pub) => (
              <tr key={pub.id}>
                <td>{pub.id}</td>
                <td>{pub.paperTitle}</td>
                <td>{pub.journalName}</td>
                <td
                  className={
                    pub.status === '3'
                      ? 'text-success'
                      : pub.status === '2'
                      ? 'text-danger'
                      : 'text-warning'
                  }
                >
                  {getStatusText(pub.status)}
                </td>
                <td>
                  {pub.status === '3' ? (
    <button
      className="btn btn-sm btn-info"
      onClick={() => handleView(pub.id)}
    >
      View
    </button>
  ) : (
    <button
      className="btn btn-sm btn-warning"
      onClick={() => handleEdit(pub.id)}
    >
      Edit
    </button>
  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                No publications found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BeforePublicationforDean;
